import { ImagePlaceholder, Typography } from "@iluvatar/ui-kit";
export function ProcessingImage({ children }: { children?: React.ReactNode }) {
  return (
    <ImagePlaceholder processing>
      <Typography variant="overline" className="mb-3">
        Processing
      </Typography>
      <Typography variant="caption" className="mb-3 text-center">
        Image uploaded and being processed
      </Typography>
      {children}
    </ImagePlaceholder>
  );
}
